export default {
  text: 'Mapę udostępnia Google. Jej załadowanie wysyła Twój adres IP do Google.',
  buttons: {
    show_map: 'Pokaż mapę',
    retry: 'Spróbuj ponownie',
  },
  errors: {
    map_unavailable: 'Nie udało się załadować mapy.',
  },
};
